import { g as o } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as s, openBlock as n, normalizeClass as d, createElementVNode as e } from "vue";
import { _ as r } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconGoogleDocs",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(i).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = o();
  }
}, h = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ e("path", {
  d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v19A1.5 1.5 0 0 0 5.5 23h13a1.5 1.5 0 0 0 1.5-1.5V7l-6-6H5.5Z",
  fill: "#4E8DF5"
}, null, -1), u = /* @__PURE__ */ e("path", {
  d: "M5.5 23A1.5 1.5 0 0 1 4 21.5v-.25a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v.25a1.5 1.5 0 0 1-1.5 1.5h-13Z",
  fill: "#417EE9"
}, null, -1), f = /* @__PURE__ */ e("path", {
  d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v.25a1.5 1.5 0 0 1 1.5-1.5h8.75L14 1H5.5Z",
  fill: "#639AF6"
}, null, -1), m = ["fill"], p = /* @__PURE__ */ e("path", {
  d: "m14 1 6 6h-4.5A1.5 1.5 0 0 1 14 5.5V1Z",
  fill: "#A6C5FA"
}, null, -1), v = /* @__PURE__ */ e("path", {
  d: "M16 12H8v1h8v-1Zm0 2H8v1h8v-1Zm-8 2h8v1H8v-1Zm6 2H8v1h6v-1Z",
  fill: "#fff"
}, null, -1), g = ["id"], A = /* @__PURE__ */ e("stop", { "stop-color": "#4E8DF5" }, null, -1), D = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#3D6ACD"
}, null, -1), Z = [
  A,
  D
];
function I(t, E, l, H, S, a) {
  return n(), s("svg", {
    "aria-label": l.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--google-docs"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Google Docs",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _,
    u,
    f,
    e("path", {
      d: "M20 12.125V7l-.875-.875h-4.22a.375.375 0 0 0-.265.64l5.36 5.36Z",
      fill: `url(#${t.uniqueID}a)`
    }, null, 8, m),
    p,
    v,
    e("defs", null, [
      e("linearGradient", {
        id: `${t.uniqueID}a`,
        x1: "17",
        y1: "12.125",
        x2: "17",
        y2: "6",
        gradientUnits: "userSpaceOnUse"
      }, Z, 8, g)
    ])
  ], 10, h);
}
const w = /* @__PURE__ */ r(c, [["render", I]]);
export {
  w as default
};
//# sourceMappingURL=google-docs.js.map
